import React, { useEffect, createElement } from 'react';
import { CheckCircle, ArrowRight, Star, ShieldCheck, AlertTriangle, BookOpen, Clock, Target, X } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { SocialProofPopup } from '../components/SocialProofPopup';
const CHECKOUT_URL = 'https://payments.vantapro.shop/cart/44849402118246:1';
export function SalesPage() {
  useEffect(() => {
    // Meta Pixel Code - safe injection
    try {
      const w = window as any;
      if (!w.fbq) {
        const n: any = w.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        w._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = document.createElement('script');
        t.async = true;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(t);
      }
      w.fbq('init', '1379305313659580');
      w.fbq('track', 'PageView');
    } catch (e) {
      console.warn('Meta Pixel failed to load', e);
    }
  }, []);
  const handleCheckout = () => {
    window.location.href = CHECKOUT_URL;
  };
  const CTAButton = ({
    text,
    subtext
  }: {
    text: string;
    subtext?: string;
  }) => <button onClick={handleCheckout} className="w-full max-w-2xl mx-auto block bg-cf-orange hover:bg-orange-600 text-white font-bold rounded-lg py-4 px-6 text-xl md:text-2xl shadow-[0_8px_0_rgb(194,65,12)] hover:shadow-[0_4px_0_rgb(194,65,12)] hover:translate-y-1 transition-all animate-pulse-glow" data-id="element-17">
      <div className="flex items-center justify-center gap-2" data-id="element-18">
        {text} <ArrowRight className="w-6 h-6 md:w-8 md:h-8" data-id="element-19" />
      </div>
      {subtext && <p className="text-sm md:text-base font-normal mt-1 opacity-90" data-id="element-20">
          {subtext}
        </p>}
    </button>;
  return <div className="min-h-screen bg-gray-50 font-sans" data-id="element-21">
      <CountdownTimer data-id="element-22" />
      <SocialProofPopup data-id="element-23" />

      {/* HERO SECTION */}
      <section className="bg-white pt-4 pb-8 px-4 border-b-4 border-cf-darkblue" data-id="element-24">
        <div className="max-w-4xl mx-auto text-center" data-id="element-25">
          <p className="text-[11px] md:text-xs mb-3 uppercase tracking-[0.2em] text-gray-500 font-semibold" data-id="element-26">
            + de 2.000 docentes ya lo usan ✅
          </p>

          <h1 className="font-black mb-2" data-id="element-27">
            <span className="text-gray-900 block text-[34px] md:text-[50px] leading-[1]" data-id="element-28">
              Mega Pack
            </span>
            <span className="text-[#2563EB] block text-[34px] md:text-[50px] leading-[1]" data-id="element-29">
              Matemática Secundaria
            </span>
          </h1>

          <div className="mb-4 cursor-pointer transform hover:scale-105 transition-transform duration-300" onClick={handleCheckout} data-id="element-30">
            <img src="https://cdn.magicpatterns.com/uploads/c1PGSn6J9FHV8ASfQ3HvgX/Diseno_sin_titulo.png" alt="MegaPack Matemática Principal" className="w-full max-w-2xl mx-auto rounded-xl shadow-2xl" data-id="element-31" />
          </div>

          <p className="text-xl md:text-2xl text-gray-700 font-medium mb-10 max-w-3xl mx-auto bg-yellow-100 p-4 rounded-lg border-l-4 border-yellow-400" data-id="element-32">
            Todo el material de Matemática que necesitás, listo para usar.
            Clases claras, organizadas y sin perder horas planificando.
          </p>

          <CTAButton text="👉 SÍ, QUIERO ACCEDER AHORA" subtext="Garantía de 7 días." data-id="element-33" />
        </div>
      </section>

      {/* PROBLEM SECTION */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-34">
        <div className="max-w-3xl mx-auto" data-id="element-35">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-36">
            Si enseñás Matemática, dejame hacerte una pregunta honesta:
          </h2>

          <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-200" data-id="element-37">
            <h3 className="text-xl font-bold text-cf-red mb-6 text-center" data-id="element-38">
              ¿Te pasa que preparar la clase te cansa más que darla?
            </h3>

            <p className="text-lg mb-4" data-id="element-39">No porque no sepas Matemática.</p>
            <p className="text-lg mb-6" data-id="element-40">
              Sino porque cada semana parece empezar desde cero.
            </p>

            <ul className="space-y-4 mb-8" data-id="element-41">
              <li className="flex items-center gap-3 text-lg text-gray-700" data-id="element-42">
                <AlertTriangle className="text-cf-red w-6 h-6 flex-shrink-0" data-id="element-43" />{' '}
                Buscar ejercicios.
              </li>
              <li className="flex items-center gap-3 text-lg text-gray-700" data-id="element-44">
                <AlertTriangle className="text-cf-red w-6 h-6 flex-shrink-0" data-id="element-45" />{' '}
                Pensar actividades.
              </li>
              <li className="flex items-center gap-3 text-lg text-gray-700" data-id="element-46">
                <AlertTriangle className="text-cf-red w-6 h-6 flex-shrink-0" data-id="element-47" />{' '}
                Preparar evaluaciones.
              </li>
              <li className="flex items-center gap-3 text-lg text-gray-700" data-id="element-48">
                <AlertTriangle className="text-cf-red w-6 h-6 flex-shrink-0" data-id="element-49" />{' '}
                Ordenar material que está en distintos archivos.
              </li>
            </ul>

            <p className="text-xl font-bold text-center bg-gray-100 p-4 rounded" data-id="element-50">
              Y cuando entrás al aula… ya estás cansado.
            </p>
            <p className="text-center mt-4 text-gray-600 italic" data-id="element-51">
              Enseñar Matemática no debería sentirse así.
            </p>
          </div>
        </div>
      </section>

      {/* THE SILENT PROBLEM */}
      <section className="py-16 px-4 bg-cf-darkblue text-white" data-id="element-52">
        <div className="max-w-4xl mx-auto text-center" data-id="element-53">
          <h2 className="text-3xl md:text-4xl font-black mb-10 text-yellow-400" data-id="element-54">
            El problema silencioso
          </h2>

          <p className="text-xl mb-8" data-id="element-55">
            Muchos docentes pasan horas cada semana:
          </p>

          <div className="grid md:grid-cols-2 gap-6 text-left max-w-3xl mx-auto mb-10" data-id="element-56">
            <div className="bg-white/10 p-6 rounded-lg" data-id="element-57">
              <ul className="space-y-4" data-id="element-58">
                <li className="flex items-start gap-3" data-id="element-59">
                  <X className="text-red-400 w-6 h-6 mt-1 flex-shrink-0" data-id="element-60" />
                  <span className="text-lg" data-id="element-61">Planificando desde cero</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-62">
                  <X className="text-red-400 w-6 h-6 mt-1 flex-shrink-0" data-id="element-63" />
                  <span className="text-lg" data-id="element-64">
                    Buscando ejercicios en distintos lugares
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-white/10 p-6 rounded-lg" data-id="element-65">
              <ul className="space-y-4" data-id="element-66">
                <li className="flex items-start gap-3" data-id="element-67">
                  <X className="text-red-400 w-6 h-6 mt-1 flex-shrink-0" data-id="element-68" />
                  <span className="text-lg" data-id="element-69">Usando material desordenado</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-70">
                  <X className="text-red-400 w-6 h-6 mt-1 flex-shrink-0" data-id="element-71" />
                  <span className="text-lg" data-id="element-72">
                    Improvisando más de lo que les gustaría
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-cf-blue p-6 rounded-xl border-2 border-yellow-400 inline-block" data-id="element-73">
            <p className="text-xl md:text-2xl font-bold italic" data-id="element-74">
              Con esa sensación de:
              <br data-id="element-75" />
              "Podría dar mejores clases si tuviera todo el material listo."
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-76">
        <div className="max-w-4xl mx-auto text-center" data-id="element-77">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6" data-id="element-78">
            La solución:{' '}
            <span className="text-cf-blue" data-id="element-79">MegaPack Matemática</span>
          </h2>

          <p className="text-xl text-gray-700 mb-12 max-w-2xl mx-auto" data-id="element-80">
            Un sistema completo de recursos de Matemática organizado por año y
            por tema para que tus clases estén listas desde hoy.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-12" data-id="element-81">
            <div className="bg-gray-50 p-6 rounded-xl shadow-md w-full max-w-xs border-t-4 border-cf-blue" data-id="element-82">
              <BookOpen className="w-12 h-12 text-cf-blue mx-auto mb-4" data-id="element-83" />
              <p className="font-bold text-lg" data-id="element-84">📂 Abrís el material</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl shadow-md w-full max-w-xs border-t-4 border-cf-blue" data-id="element-85">
              <Target className="w-12 h-12 text-cf-blue mx-auto mb-4" data-id="element-86" />
              <p className="font-bold text-lg" data-id="element-87">👆 Elegís el tema</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl shadow-md w-full max-w-xs border-t-4 border-cf-blue" data-id="element-88">
              <Clock className="w-12 h-12 text-cf-blue mx-auto mb-4" data-id="element-89" />
              <p className="font-bold text-lg" data-id="element-90">✏️ Lo aplicás en clase</p>
            </div>
          </div>

          <div className="text-2xl font-bold text-cf-red mb-10" data-id="element-91">
            <p data-id="element-92">Sin improvisar.</p>
            <p data-id="element-93">Sin empezar desde cero.</p>
          </div>

          <CTAButton text="👉 OBTENER MI MEGAPACK HOY" data-id="element-94" />
        </div>
      </section>

      {/* WHAT'S INCLUDED */}
      <section className="py-16 px-4 bg-gray-100 border-y border-gray-200" data-id="element-95">
        <div className="max-w-4xl mx-auto" data-id="element-96">
          <h2 className="md:text-4xl font-black text-center mb-10 text-cf-darkblue text-[23px]" data-id="element-97">
            🧮 ¿QUÉ INCLUYE ESTE MEGA PACK DE MATEMÁTICA SECUNDARIA? ✨📘
          </h2>

          <div className="bg-white p-8 rounded-2xl shadow-xl" data-id="element-98">
            <p className="text-lg font-bold mb-6 text-center bg-yellow-100 p-3 rounded" data-id="element-99">
              ✨ Material completo de Matemática para 1° a 6° año, organizado
              por nivel, con teoría y actividades.
            </p>

            <div className="space-y-6" data-id="element-100">
              <div className="flex gap-4" data-id="element-101">
                <div className="text-2xl" data-id="element-102">📘</div>
                <div data-id="element-103">
                  <h4 className="font-bold text-lg" data-id="element-104">1° Año:</h4>
                  <p className="text-gray-700 font-[600]" data-id="element-105">
                    números naturales, operaciones básicas, propiedades, sistema
                    decimal, divisibilidad y MCM.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-106">
                <div className="text-2xl" data-id="element-107">📗</div>
                <div data-id="element-108">
                  <h4 className="font-bold text-lg" data-id="element-109">2° Año:</h4>
                  <p className="text-gray-700 font-[600]" data-id="element-110">
                    lenguaje algebraico, expresiones algebraicas, términos
                    semejantes, productos notables, factoreo, ecuaciones y
                    función lineal.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-111">
                <div className="text-2xl" data-id="element-112">📙</div>
                <div data-id="element-113">
                  <h4 className="font-bold text-lg" data-id="element-114">3° Año:</h4>
                  <p className="text-gray-700 font-[600]" data-id="element-115">
                    números racionales e irracionales, radicación, extracción de
                    factores, radicales semejantes, intervalos y aproximación.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-116">
                <div className="text-2xl" data-id="element-117">📕</div>
                <div data-id="element-118">
                  <h4 className="font-bold text-lg" data-id="element-119">4° Año:</h4>
                  <p className="text-gray-700 font-[600]" data-id="element-120">
                    racionalización de denominadores, ecuaciones e inecuaciones
                    con módulo y análisis de funciones.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-121">
                <div className="text-2xl" data-id="element-122">📒</div>
                <div data-id="element-123">
                  <h4 className="font-bold text-lg" data-id="element-124">5° Año:</h4>
                  <p className="text-gray-700 font-[600]" data-id="element-125">
                    logaritmos, propiedades, cambio de base, ecuaciones
                    logarítmicas y función exponencial.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-126">
                <div className="text-2xl" data-id="element-127">📓</div>
                <div data-id="element-128">
                  <h4 className="font-bold text-lg" data-id="element-129">6° Año:</h4>
                  <p className="text-gray-700 font-[600]" data-id="element-130">
                    números complejos, operaciones y funciones a trozos.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200" data-id="element-131">
              <p className="font-bold text-center text-cf-blue text-lg mb-2" data-id="element-132">
                📚 Teoría clara, ejemplos resueltos y actividades prácticas.
              </p>
              <p className="text-center text-gray-700 font-[600]" data-id="element-133">
                🎁 Bonos incluidos: Fundamentos de Matemática · Razonamiento
                Matemático · Problemas Matemáticos.
              </p>
            </div>
          </div>

          <div className="mt-10" data-id="element-134">
            <CTAButton text="👉 Acceder ahora con descuento" data-id="element-135" />
          </div>
        </div>
      </section>

      {/* BEFORE VS AFTER */}
      <section className="py-16 px-4 bg-white" data-id="element-136">
        <div className="max-w-4xl mx-auto" data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-138">
            Antes vs Después
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-139">
            <div className="bg-red-50 p-8 rounded-xl border-2 border-red-200 relative" data-id="element-140">
              <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-red-500 text-white font-bold py-1 px-6 rounded-full" data-id="element-141">
                Antes
              </div>
              <ul className="space-y-4 mt-4" data-id="element-142">
                <li className="flex items-center gap-3 text-gray-700 font-[500]" data-id="element-143">
                  <X className="text-red-500 w-6 h-6" data-id="element-144" /> Improvisación constante
                </li>
                <li className="flex items-center gap-3 text-gray-700 font-[500]" data-id="element-145">
                  <X className="text-red-500 w-6 h-6" data-id="element-146" /> Cansancio al planificar
                </li>
                <li className="flex items-center gap-3 text-gray-700 font-[500]" data-id="element-147">
                  <X className="text-red-500 w-6 h-6" data-id="element-148" /> Horas extra en casa
                </li>
                <li className="flex items-center gap-3 text-gray-700 font-[500]" data-id="element-149">
                  <X className="text-red-500 w-6 h-6" data-id="element-150" /> Estrés antes de cada
                  clase
                </li>
              </ul>
            </div>

            <div className="bg-green-50 p-8 rounded-xl border-2 border-green-400 relative shadow-lg transform md:scale-105" data-id="element-151">
              <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-green-500 text-white font-bold py-1 px-6 rounded-full" data-id="element-152">
                Después
              </div>
              <ul className="space-y-4 mt-4" data-id="element-153">
                <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-154">
                  <CheckCircle className="text-green-500 w-6 h-6" data-id="element-155" /> Clases
                  claras y organizadas
                </li>
                <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-156">
                  <CheckCircle className="text-green-500 w-6 h-6" data-id="element-157" /> Material
                  listo para usar
                </li>
                <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-158">
                  <CheckCircle className="text-green-500 w-6 h-6" data-id="element-159" /> Más
                  seguridad al explicar
                </li>
                <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-160">
                  <CheckCircle className="text-green-500 w-6 h-6" data-id="element-161" /> Más
                  tranquilidad para enseñar
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-16 px-4 bg-gradient-to-b from-cf-darkblue to-[#0a1628] text-white relative overflow-hidden" data-id="element-162">
        {/* Background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-yellow-400/5 rounded-full blur-3xl" data-id="element-163" />

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-164">
          <div className="text-center mb-12" data-id="element-165">
            <div className="inline-block bg-red-600 text-white font-black px-6 py-2 rounded-full text-lg md:text-xl mb-6 animate-pulse shadow-lg shadow-red-600/30" data-id="element-166">
              🔥 SOLO POR HOY: 3 BONOS GRATIS 🔥
            </div>
            <h2 className="text-4xl md:text-6xl font-black text-yellow-400 mb-4" data-id="element-167">
              🎁 Regalos Especiales
            </h2>
            <h3 className="text-2xl md:text-3xl font-bold" data-id="element-168">
              BONOS INCLUIDOS CON TU COMPRA
            </h3>
            <p className="text-xl mt-3 text-white/80" data-id="element-169">
              (Valorados en más de $30.000 — hoy los llevás{' '}
              <span className="text-yellow-400 font-black" data-id="element-170">GRATIS</span>)
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-171">
            {/* Bono 1 */}
            <div className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-2xl flex flex-col relative group border-2 border-yellow-400/50 hover:border-yellow-400 transition-colors" data-id="element-172">
              <div className="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-black px-3 py-1 rounded-bl-lg rounded-tr-xl z-10" data-id="element-173">
                GRATIS HOY
              </div>
              <div className="bg-gradient-to-r from-cf-blue to-blue-700 text-white text-center py-3 font-black text-lg tracking-wide" data-id="element-174">
                🎁 BONO #1 — Valor:{' '}
                <span className="line-through opacity-70" data-id="element-175">$12.990</span>{' '}
                <span className="text-yellow-300" data-id="element-176">$0</span>
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-177">
                <h4 className="text-xl font-black mb-2 text-cf-darkblue" data-id="element-178">
                  Problemas Matemáticos
                </h4>
                <p className="mb-6 flex-1 font-[600] text-gray-600" data-id="element-179">
                  Problemas matemáticos, ejercicios cotidianos y soluciones paso
                  a paso.
                </p>
                <img src="https://cdn.magicpatterns.com/uploads/fi1Mme7T5Hc4cwuWWxPYpL/Diseno_sin_titulo_(3).png" alt="Bono 1" className="w-full aspect-square object-cover rounded-lg cursor-pointer hover:scale-105 transition-transform shadow-md" onClick={handleCheckout} data-id="element-180" />
              </div>
            </div>

            {/* Bono 2 */}
            <div className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-2xl flex flex-col relative group border-2 border-yellow-400/50 hover:border-yellow-400 transition-colors md:scale-105 md:-translate-y-2" data-id="element-181">
              <div className="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-black px-3 py-1 rounded-bl-lg rounded-tr-xl z-10" data-id="element-182">
                GRATIS HOY
              </div>
              <div className="bg-gradient-to-r from-cf-blue to-blue-700 text-white text-center py-3 font-black text-lg tracking-wide" data-id="element-183">
                🎁 BONO #2 — Valor:{' '}
                <span className="line-through opacity-70" data-id="element-184">$12.990</span>{' '}
                <span className="text-yellow-300" data-id="element-185">$0</span>
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-186">
                <h4 className="text-xl font-black mb-2 text-cf-darkblue" data-id="element-187">
                  Fichas Completas
                </h4>
                <p className="mb-6 flex-1 font-[600] text-gray-600" data-id="element-188">
                  Fichas de geometría, álgebra, trigonometría y aritmética.
                  Teoría y ejercicios listos para usar.
                </p>
                <img src="https://cdn.magicpatterns.com/uploads/1BamQoFWBAVBgjCuZdoKy1/Diseno_sin_titulo_(2).png" alt="Bono 2" className="w-full aspect-square object-cover rounded-lg cursor-pointer hover:scale-105 transition-transform shadow-md" onClick={handleCheckout} data-id="element-189" />
              </div>
            </div>

            {/* Bono 3 */}
            <div className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-2xl flex flex-col relative group border-2 border-yellow-400/50 hover:border-yellow-400 transition-colors" data-id="element-190">
              <div className="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-black px-3 py-1 rounded-bl-lg rounded-tr-xl z-10" data-id="element-191">
                GRATIS HOY
              </div>
              <div className="bg-gradient-to-r from-cf-blue to-blue-700 text-white text-center py-3 font-black text-lg tracking-wide" data-id="element-192">
                🎁 BONO #3 — Valor:{' '}
                <span className="line-through opacity-70" data-id="element-193">$9.990</span>{' '}
                <span className="text-yellow-300" data-id="element-194">$0</span>
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-195">
                <h4 className="text-xl font-black mb-2 text-cf-darkblue" data-id="element-196">
                  Razonamiento Matemático
                </h4>
                <p className="mb-6 flex-1 font-[600] text-gray-600" data-id="element-197">
                  Actividades de razonamiento matemático, práctica de resolución
                  de problemas y pensamiento lógico.
                </p>
                <img src="https://cdn.magicpatterns.com/uploads/nr7UcePkUip6o7rGf1mFUt/Diseno_sin_titulo_(1).png" alt="Bono 3" className="w-full aspect-square object-cover rounded-lg cursor-pointer hover:scale-105 transition-transform shadow-md" onClick={handleCheckout} data-id="element-198" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-199">
        <div className="max-w-5xl mx-auto" data-id="element-200">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-gray-900" data-id="element-201">
            Lo que dicen nuestros colegas docentes
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-202">
            {[{
            name: 'Silvia, 42 años',
            role: 'Profesora de Secundaria',
            text: '¡Me salvó la vida! Antes pasaba todo el domingo planificando, ahora solo abro el PDF y ya tengo la clase lista. Mis alumnos notan que estoy más relajada.'
          }, {
            name: 'Martín, 35 años',
            role: 'Docente de Matemática',
            text: 'El material de 4to y 5to año es excelente. Los chicos entienden mejor con los ejemplos visuales y yo trabajo menos en casa. Una inversión que vale cada peso.'
          }, {
            name: 'Andrea, 50 años',
            role: 'Profesora de 1° a 3° año',
            text: 'Compré el pack con dudas, pero valió cada centavo. Las actividades de razonamiento son geniales y me ahorran horas de búsqueda en internet.'
          }, {
            name: 'Pablo, 38 años',
            role: 'Docente de Secundaria',
            text: 'Por fin un recurso adaptado a nuestra currícula. Los ejercicios resueltos me ahorran muchísimo tiempo en la corrección. Lo recomiendo 100%.'
          }, {
            name: 'Valeria, 45 años',
            role: 'Profesora de Matemática',
            text: 'Los bonos de geometría son espectaculares. Recomiendo este MegaPack a cualquier colega que quiera recuperar su tiempo libre los fines de semana.'
          }].map((testimonial, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-203">
                <div className="flex text-yellow-400 mb-3" data-id="element-204">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-205" />)}
                </div>
                <p className="text-gray-700 italic mb-4" data-id="element-206">
                  "{testimonial.text}"
                </p>
                <div data-id="element-207">
                  <p className="font-bold text-gray-900" data-id="element-208">{testimonial.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-209">{testimonial.role}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* PRICING & URGENCY */}
      <section className="py-16 px-4 bg-gradient-to-b from-blue-700 via-blue-800 to-blue-900 border-t-4 border-orange-500 relative overflow-hidden" data-id="element-210">
        {/* Background decoration */}
        <div className="absolute inset-0 opacity-10" data-id="element-211">
          <div className="absolute top-0 left-0 w-72 h-72 bg-orange-500 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-212" />
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-500 rounded-full translate-x-1/3 translate-y-1/3" data-id="element-213" />
        </div>

        <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-214">
          {/* Big urgency title */}
          <div className="mb-10" data-id="element-215">
            <div className="inline-flex items-center gap-2 bg-orange-500 text-white font-black px-6 py-2 rounded-full text-sm md:text-base mb-6 animate-pulse shadow-lg" data-id="element-216">
              <Clock className="w-5 h-5" data-id="element-217" />
              ESTA OFERTA SE TERMINA PRONTO
              <Clock className="w-5 h-5" data-id="element-218" />
            </div>

            <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-4 leading-none tracking-tight drop-shadow-lg" data-id="element-219">
              🔥 OFERTA POR
              <br data-id="element-220" />
              <span className="text-orange-400" data-id="element-221">TIEMPO LIMITADO</span>
            </h2>

            <p className="text-xl md:text-2xl text-white/90 font-semibold max-w-2xl mx-auto" data-id="element-222">
              Accedé a MegaPack Matemática Secundaria + los 3 Bonos de regalo
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-2xl border-4 border-blue-500 mb-10 text-left" data-id="element-223">
            <h3 className="text-xl font-black mb-6 text-center text-gray-900" data-id="element-224">
              📦 Lo que vas a recibir hoy:
            </h3>

            <ul className="space-y-3 max-w-md mx-auto mb-8" data-id="element-225">
              <li className="flex items-center gap-2 font-medium" data-id="element-226">
                <CheckCircle className="text-green-500 w-5 h-5" data-id="element-227" /> 6
                cuadernillos de Matemática (1° a 6° año)
              </li>
              <li className="flex items-center gap-2 font-medium" data-id="element-228">
                <CheckCircle className="text-green-500 w-5 h-5" data-id="element-229" /> Bono #1
              </li>
              <li className="flex items-center gap-2 font-medium" data-id="element-230">
                <CheckCircle className="text-green-500 w-5 h-5" data-id="element-231" /> Bono #2
              </li>
              <li className="flex items-center gap-2 font-medium" data-id="element-232">
                <CheckCircle className="text-green-500 w-5 h-5" data-id="element-233" /> Bono #3
              </li>
              <li className="flex items-center gap-2 font-medium" data-id="element-234">
                <CheckCircle className="text-green-500 w-5 h-5" data-id="element-235" /> Teoría clara
                + ejercicios resueltos
              </li>
              <li className="flex items-center gap-2 font-medium" data-id="element-236">
                <CheckCircle className="text-green-500 w-5 h-5" data-id="element-237" /> Actividades
                prácticas y material visual
              </li>
            </ul>

            <div className="text-center border-t border-gray-200 pt-8" data-id="element-238">
              <p className="text-xl text-gray-500 line-through mb-2" data-id="element-239">
                Precio regular: $49.990
              </p>
              <p className="text-2xl font-bold text-cf-red mb-2" data-id="element-240">🔥HOY SOLO:</p>
              <p className="text-6xl font-black text-gray-900 mb-8" data-id="element-241">$19.990</p>

              <div className="grid grid-cols-2 gap-4 text-sm font-bold text-gray-600 mb-8 max-w-sm mx-auto" data-id="element-242">
                <div className="flex items-center justify-center gap-1" data-id="element-243">
                  <CheckCircle className="w-4 h-4 text-green-500" data-id="element-244" /> Acceso
                  inmediato
                </div>
                <div className="flex items-center justify-center gap-1" data-id="element-245">
                  <CheckCircle className="w-4 h-4 text-green-500" data-id="element-246" /> Un solo
                  pago
                </div>
                <div className="flex items-center justify-center gap-1" data-id="element-247">
                  <CheckCircle className="w-4 h-4 text-green-500" data-id="element-248" /> Descarga
                  digital
                </div>
                <div className="flex items-center justify-center gap-1" data-id="element-249">
                  <CheckCircle className="w-4 h-4 text-green-500" data-id="element-250" /> Acceso de
                  por vida
                </div>
              </div>

              <CTAButton text="👉 OBTENER MI MEGAPACK HOY" data-id="element-251" />
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-12 px-4 bg-gray-900 text-white text-center" data-id="element-252">
        <div className="max-w-2xl mx-auto flex flex-col items-center" data-id="element-253">
          <ShieldCheck className="w-20 h-20 text-yellow-400 mb-6" data-id="element-254" />
          <h2 className="text-3xl font-black mb-4" data-id="element-255">Garantía sin riesgo</h2>
          <p className="text-lg text-gray-300" data-id="element-256">
            Tenés 7 días de garantía. Si el material no cumple tus expectativas,
            te devolvemos el 100% de tu dinero sin hacer preguntas.
          </p>
        </div>
      </section>
    </div>;
}